import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

const app = createApp(App);

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import { vMaska } from "maska/vue";

const options = {
    confirmButtonColor: '#efce03',
    cancelButtonColor: '#1d1d29',
};

// const urlAPI = 'http://127.0.0.1:8000';
const urlAPI = 'https://app.reciclagembrasil.com.br';

app.config.globalProperties.baseStorage = urlAPI + '/storage/';
axios.defaults.baseURL = urlAPI + '/api/v1';
app.config.globalProperties.$api = urlAPI + '/api/v1/';

axios.defaults.headers.common['Accept'] = 'application/json';
app.config.globalProperties.$http = axios;

app.directive("maska", vMaska);
app.use(VueSweetalert2, options);

app.use(store)
app.use(router)
app.mount('#app')